import React, { useState, FormEvent, useContext, Fragment, useEffect } from "react";
import { Segment, Form, Button, Dropdown, Input, Image, Grid } from "semantic-ui-react";
import { IAsset as IAsset, IAssetKeep } from "../../../app/models/asset";
import { v4 as uuid } from "uuid";
import AssetStore from "../../../app/stores/assetStore";
import { observer } from "mobx-react-lite";
import { RouteComponentProps } from "react-router";
import AssetPhotoDropzone from "./AssetPhotoDropzone";
import LoadingComponent from "../../../app/layout/LoadingComponent";

interface DetailParams {
  id: string;
}

const AssetEditForm: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
  history,
}) => {
  const assetStore = useContext(AssetStore);
  const { loadAsset, editAsset, clearAsset, loadEmployees, employeesByName, submitting, loadingInitial } = assetStore;
  
  
  const [asset, setAsset] = useState<IAsset>({
    id: "",
    createdAt: "",
    updatedAt: "",
    code: "",
    assetName: "",
    type: "",
    model: "",
    price: 0,
    purchaseDate: "",
    status: "",
    life: "",
    inspectionDate: "",
    inspectionFrequency: 0,
    serviceDate: "",
    regoDate: "",
    insuranceDate: "",
    photoUrl: [""],
    barcodeFileId: "",
    barcodeUrl: "",
    remark: "",
    keep: [{
      id: "",
      createdAt: "",
      updatedAt: "",
      assetId: "",
      keeper: "",
      keepDate: "",
      remark: "",
    }],
  });
  
  useEffect(() => {
    loadAsset(match.params.id).then((asset) => {
      setAsset(asset);
      loadEmployees();
    });

    return () => {
      clearAsset();
    };
  }, []);

  const [files, setFiles] = useState<any[]>([]);
  
  const handleSubmit = () => {
    editAsset(files, asset).then(() =>
      history.push(`/dailymanagement/asset`)
    );
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setAsset({ ...asset, [name]: value });
  };

  const employeeOptions = employeesByName.map(function (employee) {
    var option = { "key": employee.id, "text": employee.name, "value": employee.name }
    return option;
  }
  );
  employeeOptions.push({key: 'Office', text: 'Office', value: 'Office'})
  
  const status = [
    { key: "In Stock", text: "In Stock", value: "In Stock" },
    { key: "Lent Out", text: "Lent Out", value: "Lent Out" }
  ];

  const type = [{ key: "Equipment", text: "Equipment", value: "Equipment" },
  { key: "Tool", text: "Tool", value: "Tool" },
  { key: "Vehicle", text: "Vehicle", value: "Vehicle" }];

  var newArray: IAssetKeep[] = [{
    id: asset.keep[0].id,
    createdAt: "",
    updatedAt: "",
    assetId: asset.keep[0].assetId,
    keeper: asset.keep[0].keeper,
    keepDate: asset.keep[0].keepDate,
    remark: "",
  }]

  return (
    <Segment clearing>
      <Form >
        <Form.Group >
          <Form.Input
            label="Asset Code"
            onChange={handleInputChange}
            name="code"
            required
            readOnly
            width="8"
            placeholder="Asset Code"
            value={asset.code}
          />
          <Form.Select
            label="Type"
            required
            onChange={(e, { name, value }) =>
              setAsset({ ...asset, [name]: value })
            }
            width="8"
            name="type"
            placeholder="Type"
            options={type}
            value={asset.type}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Input
            label="Asset Name"
            onChange={handleInputChange}
            required
            readOnly
            name="assetName"
            placeholder="Asset Name"
            value={asset.assetName}
          />
          <Form.Input
            label="Model"
            onChange={handleInputChange}
            name="model"
            placeholder="Model"
            value={asset.model}
          />
          <Form.Select
            label="Status"
            required
            onChange={(e, { name, value }) =>
              setAsset({ ...asset, [name]: value })
            }
            options={status}
            name="status"
            placeholder="Status"
            value={asset.status}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Input
            label="Price"
            onChange={handleInputChange}
            name="price"
            type="number"
            placeholder="Price"
            value={asset.price}
          />
          <Form.Input
            label="Purchase Date"
            onChange={handleInputChange}
            name="purchaseDate"
            type="date"
            placeholder="Purchase Date"
            value={asset.purchaseDate}
          />
          <Form.Input
            label="Service Life"
            onChange={handleInputChange}
            name="life"
            placeholder="Service Life"
            value={asset.life}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Select
            label="Keeper"
            required
            search
            onChange={(e, { name, value }) => {
              newArray[0].keeper = value!.toString();
              setAsset({
                ...asset, keep: newArray
              })
            }
            }
            options={employeeOptions}
            name="keeper"
            placeholder="Keeper"
            value={asset.keep[0].keeper}
          />
          <Form.Input
            label="Keep Date"
            required
            onChange={(e, { name, value }) => {
              newArray[0].keepDate = value;
              setAsset({
                ...asset, keep: newArray
              })
            }
            }
            name="keepDate"
            type="date"
            placeholder="Keep Date"
            value={asset.keep[0].keepDate}
          />
        </Form.Group>
        {(asset.type === 'Tool') && 
         <Form.Group>
         <Form.Input
            label="Next Inspection Date"
            onChange={handleInputChange}
            name="inspectionDate"
            type="date"
            width="6"
            placeholder="Inspection Date"
            value={asset.inspectionDate}
         /> 
         <Form.Button
            onClick={() => {
              let newDate = new Date(new Date(asset.inspectionDate).setMonth(new Date(asset.inspectionDate).getMonth()+asset.inspectionFrequency));
              setAsset({ ...asset, ["inspectionDate"]:  newDate.toISOString().split('T')[0]})}}
            width="2"
            floated="left"
            content="Renew"
            style={{ marginTop: '1.7em' }}
          />
         <Form.Input
            label="Inspection Frequency (number of months, e.g. input 12 for 12 months)"
            onChange={handleInputChange}
            name="inspectionFrequency"
            type="number"
            width="8"
            placeholder="Inspection Frequency"
            value={asset.inspectionFrequency}
         />
         </Form.Group>}
         {(asset.type === 'Vehicle') && 
         <Form.Group>
         <Form.Input
            label="Next Service Date"
            onChange={handleInputChange}
            name="serviceDate"
            type="date"
            width="6"
            placeholder="Service Date"
            value={asset.serviceDate}
          /> 
          <Form.Button
            onClick={() => {
              let newDate = new Date(new Date(asset.serviceDate).setMonth(new Date(asset.serviceDate).getMonth()+12));
              setAsset({ ...asset, ["serviceDate"]:  newDate.toISOString().split('T')[0]})}}
            width="2"
            floated="left"
            content="Renew"
            style={{ marginTop: '1.7em' }}
          />
          </Form.Group> }

        {(asset.type === 'Vehicle') &&  
        <Form.Group>
        <Form.Input
            label="Next Rego Date"
            onChange={handleInputChange}
            name="regoDate"
            type="date"
            width="6"
            placeholder="Rego Date"
            value={asset.regoDate}
          />
          <Form.Button
            onClick={() => {
              let newDate = new Date(new Date(asset.regoDate).setMonth(new Date(asset.regoDate).getMonth()+12));
              setAsset({ ...asset, ["regoDate"]:  newDate.toISOString().split('T')[0]})}}
            width="2"
            floated="left"
            content="Renew"
            style={{ marginTop: '1.7em' }}
          />
          </Form.Group> }
        {(asset.type === 'Vehicle') && 
        <Form.Group>
        <Form.Input
            label="Next Insurance Date"
            onChange={handleInputChange}
            name="insuranceDate"
            type="date"
            width="6"
            placeholder="Insurance Date"
            value={asset.insuranceDate}
          />
          <Form.Button
            onClick={() => {
              let newDate = new Date(new Date(asset.insuranceDate).setMonth(new Date(asset.insuranceDate).getMonth()+12));
              setAsset({ ...asset, ["insuranceDate"]:  newDate.toISOString().split('T')[0]})}}
            width="2"
            floated="left"
            content="Renew"
            style={{ marginTop: '1.7em' }}
          />
          </Form.Group>}
        <Form.TextArea
          label="Remark"
          onChange={handleInputChange}
          name="remark"
          rows={2}
          placeholder="Remark"
          value={asset.remark}
        />
        <div>
          <Button
            color="grey"
            content={<AssetPhotoDropzone setFiles={setFiles} />}
          />
          {(files.length > 0 || asset.photoUrl.length > 0) && (
            <Fragment>
              <Grid>
              {asset.photoUrl.map(url => ( <Grid.Column width='4'>
              <Image
                src={`/${url}`}
              />
              </Grid.Column>))}
              {files.map(file => ( <Grid.Column width='4'>
              <Image
                src={file.preview}
              />
              </Grid.Column>))}
              </Grid>
              <Button
                icon='close'
                size='small'
                color='red'
                onClick={() => {setFiles([]); setAsset({ ...asset, ['photoUrl']: [''] });}}
              />
            </Fragment>
          )}
        </div>
        <Button
          loading={submitting}
          floated="right"
          positive
          onClick={handleSubmit}
          content="Submit"
        />
        <Button
          onClick={() => history.push("/dailymanagement/asset")}
          floated="right"
          type="button"
          content="Cancel"
        />
      </Form>
    </Segment>
  );
};

export default observer(AssetEditForm);
